import { SalesHeader } from "app/modules/transactions/sales/models/sales-header.model";
import {
  SalesItem,
  SearchedSaleItem,
} from "app/modules/transactions/sales/models/sales-item.model";
import { SalesSummary } from "app/modules/transactions/sales/models/sales-summary.model";

export interface SalesState {
  header: SalesHeader;
  items: SalesItem[];
  summary: SalesSummary;
  saveSuccess: boolean;
  saveError: string;
  loading: boolean;
  searchResultsByRow: {
    [rowIndex: number]: SearchedSaleItem[];
  };
  itemSearchError: any;
}

export const initialSalesState: SalesState = {
  header: {
    customerId: "",
    billingMode: "CASH",
    doctorId: "",
    invoiceDate: new Date(),
  },
  items: [],
  summary: {
    grossAmount: 0,
    totalDiscount: 0,
    totalTax: 0,
    netAmount: 0,
    roundOff: 0,
    invoiceAmount: 0,
  },
  saveSuccess: false,
  saveError: null,
  loading: false,
  searchResultsByRow: {},
  itemSearchError: null,
};
